module.exports = __webpack_public_path__ + "static/media/main-beer.95ffe72c.png";